export const sdkSources = {
  Prod: "https://app.glean.com/glean-web-sdk-latest.min.js",
  Canary: "https://canary.glean.com/glean-web-sdk-latest.min.js",
  Dev: "https://dev.glean.com/glean-web-sdk-latest.min.js",
  Local: "https://local.glean.com:8888/glean-web-sdk-latest.min.js",
} as const;

export type SdkEnvironment = keyof typeof sdkSources;

export const getSdkEnvironment = (source?: string): SdkEnvironment | "" => {
  return (Object.entries(sdkSources).find(([, url]) => url === source)?.[0] ?? "") as SdkEnvironment | "";
};

export const getSdkSource = (environment?: string | null): string | undefined => {
  if (!environment) return undefined;

  const normalizedEnvironment = Object.keys(sdkSources).find(
    (value) => value.toLowerCase() === environment.toLowerCase()
  ) as SdkEnvironment | undefined;

  return normalizedEnvironment ? sdkSources[normalizedEnvironment] : undefined;
};
